import React, { useState, useRef, useEffect } from "react";
import { McButton, McBadge } from "@maersk-global/mds-react-wrapper";
import FilterMenu from "./FilterMenu";
import "./CSS/FilterButton.css";

function FilterButton({
  columns,
  data,
  onApply,
  activeFilters,
  setActiveFilters,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const filterButtonRef = useRef(null);

  const operators = [
    { value: "contains", label: "Contains" },
    { value: "Does not contain", label: "Does not contain" },
    { value: "equals", label: "Equals" },
    { value: "Is not", label: "Is not" },
    { value: "startsWith", label: "Starts with" },
    { value: "endsWith", label: "Ends with" },
  ];

  const toggleMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  const handleApply = (conditions) => {
    const validConditions = conditions.filter(
      (condition) =>
        condition.field && condition.operator && condition.value.trim()
    );
    setActiveFilters(validConditions);
    onApply && onApply(validConditions);
    setIsMenuOpen(false);
  };

  const handleOverlayClick = () => {
    setIsMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterButtonRef.current &&
        !filterButtonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <>
      <div className="filter-button-container" ref={filterButtonRef}>
        <McButton
          label={activeFilters.length > 0 ? `Filters (${activeFilters.length})` : "Filters"}
          icon="sliders-horizontal"
          appearance="neutral"
          variant="plain"
          fit="small"
          click={toggleMenu}
          badge={activeFilters.length > 0 ? activeFilters.length.toString() : undefined}
        >
            {activeFilters.length > 0 && (
                <McBadge
                    display="pinned"
                    slot="badge"
                    label={activeFilters.length}
                    max={99}
                    appearance="info"
                    position="top"
                ></McBadge>
            )}
        </McButton>
        
        <div className={`filter-dropdown ${isMenuOpen ? "open" : ""}`}>
          {isMenuOpen && (
            <FilterMenu
              columns={columns}
              operators={operators}
              data={data}
              onApply={handleApply}
              onCancel={() => setIsMenuOpen(false)}
              setIsMenuOpen={setIsMenuOpen}
              setActiveFilters={setActiveFilters}
              activeFilters={activeFilters}
            />
          )}
        </div>
      </div>
      
      <div
        className={`filter-overlay ${isMenuOpen ? "open" : ""}`}
        onClick={handleOverlayClick}
      />
    </>
  );
}

export default FilterButton;
